import React from "react";
import {
  Container,
  Link,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@material-ui/core";
import List from "@material-ui/core/List";
import Chip from "@material-ui/core/Chip";
import DescriptionIcon from "@material-ui/icons/Description";
import Button from "./Button/Button";
import deleteGroup from "./callDeleteGroup";
import { RepeatOneSharp } from "@material-ui/icons";

export default function AssetsGroupComponent(assets, classes) {
  const groups = [];
  assets.forEach((asset) => {
    let index = groups.findIndex((g) => g.groupId === asset.groupId);
    if (index < 0 || index === undefined) {
      console.log("not exist: " + asset.groupId);
      groups.push({
        groupId: asset.groupId,
        applicationId: asset.applicationId,
        metadata: asset.metadata,
        assets: [asset],
      });
    } else {
      groups[index].assets.push(asset);
    }
  });

  return (
    <Container>
      {groups.map((group) => (
        <Container>
          <List className={classes.groupCell}>
            <ListItem>
              <Chip label={group.groupId} className={classes.groupId} />
              <Button
                onClick={(event) => {
                  deleteGroup(group, event);
                }}
              />
            </ListItem>
            <br />
            <ListItem divider>
              <ListItemText secondary="Author:" className={classes.label} />
              <ListItemText primary={group.metadata.author} />
            </ListItem>

            <ListItem divider>
              <ListItemText secondary="Date:" className={classes.label} />
              <ListItemText primary={group.metadata.creationDate} />
            </ListItem>
            <ListItem className={classes.yeah}>
              <ListItemText secondary="Files:" className={classes.label} />
              <List>
                {group.assets.map((asset) => (
                  <ListItem className={classes.heading}>
                    <ListItemIcon>
                      <DescriptionIcon />
                    </ListItemIcon>
                    <Link
                      href={asset.uri}
                      target="_blank"
                      className={classes.link}
                    >
                      {asset.name}
                    </Link>
                  </ListItem>
                ))}
              </List>
            </ListItem>
          </List>
          <br />
        </Container>
      ))}
    </Container>
  );
}
